export const FAQ_BLOCK_s5 = {
  "blockType": "FAQ",
  "blockDesign": "FAQDesign1",
  "editFormName": "FAQ_FORM_1",
  "styleProps": {
    "background-color": "#000000",
    "background-image": "url('')",
    "padding": "120px 120px 120px 120px"
  },
  "sectionConfigs": {
    "headerTextStyleProps": {
      "font-size": "1.25rem",
      "line-height": "1.75rem",
      "font-weight": "500",
      "padding": "14px 30px 14px 30px",
      "color": "#cccccc"
    },
    "bodyTextStyleProps": {
      "padding": "14px 30px 14px 30px",
      "color": ""
    },
    "sectionStyleProps": {
      "backgroundColor": "#f8f8f8",
      "padding": "10px",
      "border-width": "0px",
      "border-radius": "1.5rem",
      "border-color": "#212d30",
      "margin": "0px 0px 8px 0px",
      "background-color": "#0E0E10"
    }
  },
  "headings": [
    {
      "text": "🟢 ",
      "styleProps": {
        "font-weight": "500",
        "text-align": "center",
        "font-size": "1.125rem",
        "line-height": "1.75rem",
        "padding": "4px 20px 4px 0px",
        "margin": "0px 20px 20px 20px",
        "color": "#A8F463",
        "background-color": "",
        "border-radius": "9999px",
        "border-color": "#424242",
        "border-width": "0px"
      },
      "alignStyleProps": {
        "text-align": "left"
      }
    },
    {
      "text": "Frequently asked",
      "styleProps": {
        "text-align": "center",
        "font-size": "4.5rem",
        "line-height": "1",
        "font-family": "'Nunito Sans', sans-serif",
        "font-weight": "400",
        "padding": "0px 20px 20px 0px",
        "margin": "0px 20px 80px 20px",
        "font-family-cust": "",
        "color": "#C1C1C1",
        "font-family-bk": "'Nunito Sans', sans-serif"
      },
      "alignStyleProps": {
        "text-align": "left"
      }
    }
  ],
  "list": [
    {
      "headerText": "What subscription tiers can I subscribe to with flezr?",
      "bodyText": "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with"
    },
    {
      "headerText": "How much does a subscription to faq cost, and for how long can I subscribe?",
      "bodyText": "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with"
    },
    {
      "headerText": "Can we use the code/art/assets in Flezr Technologies' example projects?",
      "bodyText": "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with"
    }
  ],
  "metaDataId": 1746184500928,
  "afterIndex": 3,
  "blockId": 1746184500928,
  "fonts": {
    "headings": [
      null,
      ""
    ]
  },
  "containerStyleProps": {
    "padding": "0px 20px 0px 20px"
  },
  "containerStylePropsTab": {
    "padding": "0px 20px 0px 20px"
  }
}